import { useEffect, useRef } from "react";
import { useStoreApi } from "reactflow";

/** Keep SVG label masks out of the camera's paint loop without rendering React. */
export default function ViewportMotionGuard() {
  const anchor = useRef(null);
  const store = useStoreApi();
  useEffect(() => {
    const root = anchor.current?.closest(".react-flow");
    if (!root) return undefined;
    let transform = store.getState().transform;
    let timer;
    const unsubscribe = store.subscribe((state) => {
      const next = state.transform;
      if (next.every((value, index) => value === transform[index])) return;
      transform = next;
      root.setAttribute("data-camera-moving", "true");
      clearTimeout(timer);
      timer = setTimeout(() => root.removeAttribute("data-camera-moving"), 140);
    });
    return () => {
      unsubscribe();
      clearTimeout(timer);
      root.removeAttribute("data-camera-moving");
    };
  }, [store]);
  return <span ref={anchor} hidden aria-hidden="true" />;
}
